import amountsConfig from '@/configs/amounts';

export const mixinAmountsHandler = {
  methods: {
    _mixinAmountsHandler_formatAmount(amount, decimals) {
      if (decimals && decimals > 0) {
        return new Number(parseFloat(amount).toFixed(decimals)).toLocaleString(amountsConfig.LOCALE, {minimumFractionDigits: decimals});
      }

      return new Number(parseFloat(amount).toFixed(decimals)).toLocaleString(amountsConfig.LOCALE, {minimumFractionDigits: 0});
    },
  },
};
